module["exports"] = [
  "gmail.com",
  "zoznam.sk",
  "azet.sk"
];
